export default "__VITE_ASSET__QRp6QetE__"